import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import VideoPlayer from 'src/shared/video/video_room/player/video_player.jsx'
import WebsocketConnection from 'src/shared/service/websocket_connection'
import logo from 'custom/flavepalfingeroft2021/logo.png'
// import Question from "../../../../shared/video/video_room/widgets/components/questions";
import Question from "./video_room/question";
import QuestionForm from "./video_room/question_form";
// import QuestionForm from "../../../../shared/video/video_room/widgets/components/question_form";
import HtmlContent from "src/shared/html_content"
import Agenda from "../../../../shared/video/video_room/widgets/components/agenda";
import "./video_room/stylesheet.scss"
import VideoRoomTabs from "../../../../shared/video/video_room/widgets/video_room_tabs";
import {setActiveTab} from "../../../../shared/video/video_room/widgets/actions";
import {directMessageSetReceiverTagOwner} from "../../../../shared/virtual_congress/exhibition_actions";
import backButton from "custom/flavepalfingeroft2021/stream/home_button.png"
import {useHistory} from "react-router-dom";
import Voting from "./video_room/voting";

export default function VideoRoom({videoRoomId, ...props}) {
  const tagOwner = useSelector(state => state.tagOwner)
  const entranceUrl = useSelector(state => state.entranceUrl)
  const videoRoom = useSelector(state => state.videoRooms.find(vr => videoRoomId ? vr.id == videoRoomId : vr.identifier == "live"))
  const event = useSelector(state => videoRoom ? state.events.find(event => event.id == videoRoom.event_id) : null)
  const activeEvent = useSelector(state => videoRoom ? state.events.find(event => event.id == videoRoom.active_event_id) : null)
  const thankYouText = useSelector(state => state.votingThankYouText)
  const [showHelp, setShowHelp] = useState(false)
  const htmlContent = useSelector(state => state.htmlContents.find(hc => hc.identifier == "vod_preview"))
  const history = useHistory()

  if (!videoRoom) {
    return <div className="alert alert-danger">Sorry, but we couldn't find a corresponding video room.</div>
  }

  console.log("Videoroom", videoRoomId, videoRoom)

  if (!activeEvent) {
    return <div className="alert alert-danger">Sorry, but we couldn't find an active Event for this video room.</div>
  }

  return <div className="row justify-content-center">
    <div className="col-12 home-button">
      <img src={backButton}
           alt="back button"
           onClick={() => history.push("/")}
           style={{
             width: "40px",
             height: "auto",
             position: "absolute",
             margin: "10px",
             cursor: "pointer",
           }}
      />

      <div className="row justify-content-center">
        <div className="col-md-10 mt-md-4">
          <div className="row">
            <div className="col-md-9 palfinger-tab">
              <div className="row justify-content-end">
                <div className="col-12 text-right p-0">
                  <VideoPlayer
                    videoRoom={videoRoom}
                    entranceUrl={entranceUrl}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12">
                {videoRoom.votings_enabled &&
                  <Voting event={activeEvent} videoRoom={videoRoom} thankYouText={"Thank you"}
                          betColors={[
                            "#9ACD32",
                            "#D3D3D3",
                            "#bdbdbd",
                            "#969696",
                            "#636363",
                            "#2ca25f"]} />
                  }
                </div>
              </div>
              <div className={"row mt-2"}>
                <div className={"col-12"}>
                  {(videoRoom.questions_enabled || videoRoom.question_form_enabled) &&
                  <div className="row">
                    <div className="col">
                      {videoRoom.questions_enabled &&
                      <div className="row">
                        <div className="col">
                          <Question videoRoom={videoRoom} event={activeEvent}/>
                        </div>
                      </div>
                      }
                      {videoRoom.question_form_enabled &&
                      <div className="row mt-2">
                        <div className="col">
                          <QuestionForm color={"#000000"} videoRoom={videoRoom}/>
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                  }
                  <div style={{fontSize: "0.8em"}}>
                    <HtmlContent identifier="video_room.below_question_text"/>
                  </div>
                  <hr/>
                  <div style={{fontSize: "0.7em"}} onClick={() => {
                      setShowHelp(!showHelp)
                    }}>
                    <HtmlContent identifier="video_room.help_text_header"/>
                    {showHelp &&
                      <HtmlContent identifier="video_room.help_text"/>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 palfinger-tab">
              {/*<div className="row justify-content-end">
                <div className="col-12 text-right p-5">
                  <img src={logo} className="img-fluid"/>
                </div>
              </div>*/}
              <div className="row">
                <div className="col-xl-12">
                  <div className="row">
                    <div className="col-12">

                      <VideoRoomTabs
                        event={activeEvent}
                        videoRoom={videoRoom}
                        useBootstrapNavigation={true}
                        showQuestionUpVote={false}
                        hideNavigationIcons={true}
                        // selectFirstVisibleTab={true}

                        questionsOptions={{
                          enabled: false,
                        }}
                        questionFormOptions={{
                          enabled: false,
                        }}
                        votingOptions={{
                          takeVotingsFrom: "parentEvent",
                          overrideEvent: activeEvent,
                          lockedBetText: "Results will be shown shortly",
                          enabled: false
                        }}
                        votingFormOptions={{
                          thankYouText: "Thank your for your answer and good luck!",
                          sendButtonText: "Submit",
                          sentButtonText: "Submitting"
                        }}
                        chatOptions={{
                          label: "Text Chat",
                          header: <>
                            <HtmlContent identifier={"direct_messages_header"} />
                          </>,
                          overrideEvent: activeEvent,
                          inputPrompt: "Ask a question!\nFragen Sie uns etwas!",
                          showEmojis: true,
                          emojis: ["👋","🙂","😋","😁","😍","💪","👌","❤️","😂"],
                          sendButtonLabel: "Send",
                          sendButtonLabelSending: "Sending ...",
                          isChatMessageNameClickable: (clickedTagOwner) => {
                            return tagOwner.id != clickedTagOwner.id && clickedTagOwner.isDirectMessagingEnabled
                          },
                          onChatMessageNameClicked: (tagOwner) => {
                            console.log("CLICKED", tagOwner)
                            dispatch(setActiveTab("direct_messaging"))
                            dispatch(directMessageSetReceiverTagOwner(tagOwner))
                          }
                        }}
                      />

                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="row align-self-end">
                    <div className="col">
                      <Agenda videoRoom={videoRoom} event={event} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="overflow-auto"
                style= {{
                  height: "300px",
                }}>
                <HtmlContent identifier={"video_room.participants"}/>
              </div>
            </div>
            <div className="col palfinger-tab">
              <div className="row">
                <div className="col-12">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <HtmlContent identifier={"video_room.css_fixes"}/>
  </div>
}


